module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-700.9bbc312.woff";